// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalEligibilityRequestSearchResponse } from './medicalEligibilityRequestSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': MedicalEligibilityRequestSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "MedicalEligibilityRequestSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1MedicalV1MedicalEligibilityRequestSearchDefaultResponse.attributeTypeMap;
    }
}
